import React, { ChangeEvent } from "react";
import Form from "react-bootstrap/Form";
import Field from "./Field";

interface TextareaProps {
  label?: React.ReactNode;
  value?: string;
  border?: string;
  margin?: string;
  placeholder?: string;
  hint?: string;
  error?: string;
  required?: boolean;
  rows?: number;
  maxLength?: number;
  showCounter?: boolean;
  name?: string;
  onChange?: (e: ChangeEvent<HTMLTextAreaElement>) => void;
  parentStyles?: React.CSSProperties;
}

const Textarea: React.FC<TextareaProps> = ({
  label,
  value,
  placeholder,
  border,
  margin,
  hint,
  error,
  required,
  rows = 5,
  maxLength,
  showCounter,
  name,
  onChange,
  parentStyles,
  ...rest
}) => {
  return (
    <Field
      label={label}
      margin={margin}
      hint={hint}
      error={error}
      required={required}
      maxLength={maxLength}
      showCounter={showCounter}
      currentLength={value?.length}
      style={parentStyles}
    >
      <Form.Control
        className={border}
        as="textarea"
        rows={rows}
        name={name}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        maxLength={maxLength}
        {...rest}
      />
    </Field>
  );
};

export default Textarea;
